import React, { useState, useMemo } from "react";
import { FormFieldSet, Button, Modal } from "../../../../../components";
import { FILE_BUTTON_PROPS, FILE_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core:     { label: "Core",     color: "#EFF6FF", textColor: "#1D4ED8" },
  display:  { label: "Display",  color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
};


function FileList() {
  const [file, setFile] = useState([]);
  const [file2, setFile2] = useState([]);
  const [multiFiles, setMultiFiles] = useState([]);

  return (
    <div>
      <div className="flex flex-col gap-6 my-5 mb-30">
        <div className="grid grid-cols-4 gap-5 my-5">
          <FormFieldSet
            value={file}
            type="file"
            onChange={setFile}
            placeholder="Upload File"
            title="File Upload"
            shadow={true}
          />

          <FormFieldSet
            value={file}
            type="file"
            onChange={setFile}
            placeholder="Upload File"
            title="File Upload Disabled"
            disabled
          />
        </div>

        <div className="grid grid-cols-4 gap-5 my-5">
          <FormFieldSet
            value={multiFiles}
            type="file"
            onChange={setMultiFiles}
            placeholder="Upload Multiple Files"
            title="Multiple File Upload"
            multiple
          />

          <FormFieldSet
            value={multiFiles}
            type="file"
            onChange={setMultiFiles}
            placeholder="Upload Multiple Files"
            title="Multiple File Upload Disabled"
            multiple
            disabled
            shadow={true}
          />
        </div>

        <div className="grid grid-cols-4 gap-5 my-5">
          <FormFieldSet
            value={file2}
            type="fileButton"
            onChange={setFile2}
            placeholder="Upload File"
            title="File Upload"
            //accept={["xls", "xlsx"]}
            accept=".xls,.xlsx"
          />
          {file2.length}

          <FormFieldSet
            value={file}
            type="fileButton"
            onChange={setFile}
            placeholder="Upload File"
            title="File Upload Disabled"
            disabled
          />
        </div>

        <Modal
          title="File Upload"
          isOpen={file2.length > 0}
          onClose={() => setFile2([])}
        >
          <div>
            <p>Uploaded File:</p>
            {file2.length > 0 && <p>{file2[0].name}</p>}
          </div>
        </Modal>
      </div>

      <PropsTable
        data={FILE_PROPS}
        title="File Upload — Props Reference"
        typeLabel='type="file"'
        categories={CATEGORIES}
      />
      <PropsTable
        data={FILE_BUTTON_PROPS}
        title="File Button — Props Reference"
        typeLabel='type="fileButton"'
        categories={CATEGORIES}
      />

      {/* file vs fileButton callout */}
      <div className="mt-6 bg-amber-50 border border-amber-200 rounded-lg p-4 text-xs text-amber-900">
        <p className="font-medium mb-2">⚠ file vs fileButton — key differences</p>
        <table className="w-full text-xs text-amber-900">
          <thead>
            <tr className="border-b border-amber-200">
              <th className="text-left py-1 pr-4 font-medium">Point</th>
              <th className="text-left py-1 pr-4 font-medium">file</th>
              <th className="text-left py-1 font-medium">fileButton</th>
            </tr>
          </thead>
          <tbody className="leading-relaxed">
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">Appearance</td>
              <td className="py-1 pr-4">Full-width input with Choose File button + filename display</td>
              <td className="py-1">Just a simple Upload button — no filename display</td>
            </tr>
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">File management</td>
              <td className="py-1 pr-4">Built-in clear button + modal to manage multiple files</td>
              <td className="py-1">None — handle in your own UI</td>
            </tr>
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">Duplicate check</td>
              <td className="py-1 pr-4">Auto-skips duplicates (name + size + type match)</td>
              <td className="py-1">No duplicate check</td>
            </tr>
            <tr>
              <td className="py-1 pr-4 font-medium">Best for</td>
              <td className="py-1 pr-4">Forms where the user should see selected files</td>
              <td className="py-1">Trigger-only upload (e.g. open a modal after selecting)</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default FileList;